import {
  withCompInfo,
  createComponentMapperModel,
  withStateRefsValues,
} from '@wix/editor-elements-integrations';

import type {
  TextEffectsSharedDefinition,
  TextEffectsSharedMapperProps,
} from '../TextEffectsShared.types';

export const props = withCompInfo<
  TextEffectsSharedMapperProps,
  TextEffectsSharedDefinition
>()(['compData', 'language'], ({ compData, language }) => {
  return {
    ...compData,
    language,
  };
});

export const stateRefs = withStateRefsValues(['reducedMotion', 'experiments']);

export default createComponentMapperModel({
  props,
  stateRefs,
});
